/* /src/components/auth/logoutCallback.jsx */
import { AuthConsumer } from "./authProvider";
import { LoadingIndicator } from "../components/common/VFX-UI";

const LogoutCallback = () => (
  <AuthConsumer>
    {({ signoutRedirectCallback }) => {
      signoutRedirectCallback();
      return <LoadingIndicator />;
    }}
  </AuthConsumer>
);

export default LogoutCallback;
